export enum ApiMsgTypes {
  success = "success",
  error = "error",
  warning = "warning",
}
export interface IResultStamp {
  message: {
    text: string;
    type: ApiMsgTypes;
  };
  errors?: {
    key: string[];
  };
}
export interface IMeta {
  current_page: number;
  from: number;
  last_page: number;
  path: string;
  per_page: number;
  to: number;
  total: number;
}
